import { useMemo } from 'react';
import type { InvitePeopleState } from '../components/InvitePeople/InvitePeopleContextInternal';
import type { InvitePeopleExperimentalFeatures } from '../types';
import { useExperimentalFeatures } from '../experiments/experimentalFeatures';

export type CommonAttributes = ReturnType<typeof toCommonAttributes>;

export const useCommonAttributesFrom = (invitePeopleState: InvitePeopleState) => {
	const experimentalFeatures = useExperimentalFeatures();
	return useMemo(
		() => toCommonAttributes(invitePeopleState, experimentalFeatures),
		[invitePeopleState, experimentalFeatures],
	);
};

export const toCommonAttributes = (
	invitePeopleState: InvitePeopleState,
	experimentalFeatures: InvitePeopleExperimentalFeatures | undefined,
) => {
	const { userEmail, loggedInEmailDomain, ...invitePeopleStateFiltered } = invitePeopleState;
	return {
		...invitePeopleStateFiltered,
		experimentalFeatures,
	};
};
